
export const ENABLE_BOLTIVE = 'ENABLE_BOLTIVE';

export function shouldLoadBoltiveTag(enable: boolean) {

    return {
        type: ENABLE_BOLTIVE,
        payload: enable
    };
}
